import React, { useEffect } from 'react';
import Button from '../../buttons/SimpleButton/Button';
import Tag from '../../tag/Tag';
import { useTranslations } from '../../../localization/useTranslations';

const PageHeaderBlock = () => {
  const translations = useTranslations();

  const backgroundColor = window?.pageHeaderData?.backgroundColor;
  const tagLabel = window?.pageHeaderData?.tagLabel;
  const tagVector = window?.pageHeaderData?.tagVector;
  const headerTitle = window?.pageHeaderData?.headerTitle;
  const quote = window?.pageHeaderData?.quote;
  const quoteAuthor = window?.pageHeaderData?.quoteAuthor;
  const authorImage = window?.pageHeaderData?.authorImage;
  const headerImage = window?.pageHeaderData?.headerImage;
  const scrollButton = window?.pageHeaderData?.scrollButton;

  const primaryButtonText = window?.pageHeaderData?.primaryButton.text;
  const primaryButtonUrl = window?.pageHeaderData?.primaryButton.url;
  const secondaryButtonText = window?.pageHeaderData?.secondaryButton.text;
  const secondaryButtonUrl = window?.pageHeaderData?.secondaryButton.url;
  const simpleLinkText = window?.pageHeaderData?.simpleLink.text;
  const simpleLinkUrl = window?.pageHeaderData?.simpleLink.url;

  useEffect(() => {
    if (backgroundColor) {
      const navigationElement = document.querySelector('.navigation');
      const leaderboardElement = document.querySelector('#leaderboard-ad');

      if (navigationElement instanceof HTMLElement) {
        navigationElement.style.backgroundColor = `var(${backgroundColor})`;
      }
      if (leaderboardElement instanceof HTMLElement) {
        leaderboardElement.style.backgroundColor = `var(${backgroundColor})`;
      }
    }
  }, [backgroundColor]);

  // Scroll function to go to the next section
  const scrollToNextSection = () => {
    const nextSection = document.getElementById('next-section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="page-header-block">
      <div className="page-header-block__background" style={{ backgroundColor: `var(${backgroundColor})` }}></div>
      <div className="row">
        <div className="col-lg-7 col-md-6">
          <div className="page-header-block__content-wrapper">
            {tagLabel && <Tag text={tagLabel} icon={tagVector ? tagVector : undefined} />}

            {headerTitle && <h2 className="heading heading-archivo heading-700">{headerTitle}</h2>}

            {/* Quote Section */}
            <div className="page-header-block__quote-wrapper">
              {authorImage && (
                <div className="page-header-block__quote-author-image">
                  <img src={authorImage} alt="Author" className="" />
                </div>
              )}

              <div className="page-header-block__quote-text-wrapper">
                {quote && (
                  <div className="page-header-block__quote">
                    <div dangerouslySetInnerHTML={{ __html: quote }} />
                  </div>
                )}

                {quoteAuthor && <div className="page-header-block__quote-author">{quoteAuthor}</div>}
              </div>
            </div>

            {/* Buttons */}
            <div className="page-header-block__buttons-wrapper">
              {!scrollButton ? (
                <>
                  {/* Primary Button */}
                  {primaryButtonText && (
                    <Button
                      className="page-header-block__primary-button"
                      label={primaryButtonText}
                      type="primary"
                      href={primaryButtonUrl ?? '#'}
                      size="large"
                    />
                  )}

                  {/* Secondary Button */}
                  {secondaryButtonText && (
                    <Button
                      className="page-header-block__secondary-button"
                      label={secondaryButtonText}
                      type="secondary"
                      href={secondaryButtonUrl ?? '#'}
                      size="large"
                    />
                  )}

                  {/* Simple Link */}
                  {simpleLinkText && simpleLinkUrl && (
                    <a href={simpleLinkUrl} className="page-header-block__simple-link link-underline-14">
                      {simpleLinkText}
                    </a>
                  )}
                </>
              ) : (
                <Button
                  size="large"
                  type="primary"
                  className="scroll-button"
                  label={translations?.newsletterPage?.seeAllNewslettersButtonLabel ?? 'See all newsletters'}
                  onClick={scrollToNextSection}
                />
              )}
            </div>
          </div>
        </div>

        {/* Main Image */}
        <div className="col-lg-5 col-md-6">
          {headerImage && (
            <div className="page-header-block__image-wrapper">
              <img src={headerImage} alt="Header" className="page-header-block__image" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeaderBlock;
